var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMembershipActivation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 480,
    viewBox: "0 0 507 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M469.939 1.77771H35.7705C16.8995 1.77771 1.60156 17.0756 1.60156 35.9466V443.164C1.60156 462.035 16.8995 477.333 35.7705 477.333H469.939C488.81 477.333 504.108 462.035 504.108 443.164V35.9466C504.108 17.0756 488.81 1.77771 469.939 1.77771Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M390.267 2.02185H36.2045C27.139 2.02185 18.4444 5.62066 12.0308 12.0275C5.61726 18.4344 2.00942 27.1253 2 36.1907V443.373C2.00942 452.438 5.61726 461.129 12.0308 467.536C18.4444 473.943 27.139 477.542 36.2045 477.542H85.1644C122 300.226 239.902 106.84 390.267 2.02185Z",
    fill: "url(#paint0_linear_4979_1084)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M469.938 479.076H35.9822C26.4453 479.076 17.2985 475.289 10.5515 468.549C3.80456 461.809 0.00942384 452.666 0 443.129V35.9467C0.00942384 26.4098 3.80456 17.2667 10.5515 10.5264C17.2985 3.78611 26.4453 -4.65604e-06 35.9822 0H470.116C479.652 -4.65604e-06 488.799 3.78611 495.546 10.5264C502.293 17.2667 506.088 26.4098 506.098 35.9467V443.129C506.093 447.866 505.153 452.556 503.332 456.929C501.51 461.302 498.843 465.272 495.484 468.612C492.124 471.952 488.138 474.596 483.754 476.391C479.37 478.187 474.675 479.099 469.938 479.076ZM35.9822 3.55556C27.3883 3.55555 19.1458 6.96706 13.0657 13.0406C6.98552 19.114 3.56498 27.3527 3.55556 35.9467V443.129C3.56498 451.723 6.98552 459.962 13.0657 466.035C19.1458 472.109 27.3883 475.52 35.9822 475.52H470.116C478.709 475.52 486.952 472.109 493.032 466.035C499.112 459.962 502.533 451.723 502.542 443.129V35.9467C502.533 27.3527 499.112 19.114 493.032 13.0406C486.952 6.96706 478.709 3.55555 470.116 3.55556H35.9822Z",
    fill: "url(#paint1_linear_4979_1084)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4979_1084",
    x1: 379.138,
    y1: 264.173,
    x2: -10.6578,
    y2: 207.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898835,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287558,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49028,
    stopColor: "#B0B0B0",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C4BFBF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#DBDBDB",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B1B1B1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4979_1084",
    x1: -0.177778,
    y1: 239.538,
    x2: 505.92,
    y2: 239.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipActivation);
export default __webpack_public_path__ + "static/media/membershipActivation.231b0472066da39e868900dcac5c2e02.svg";
export { ForwardRef as ReactComponent };